module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [_c('span', {
    staticClass: "icon icon-left goback",
    staticStyle: {
      "font-size": ".8rem"
    },
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "4rem"
    }
  }, [_vm._v("\n         订单详情\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "font-size": ".6rem"
    }
  }, [_vm._v("\n     重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。\n\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('header', [_c('div', {
    staticClass: " bar_1 buttons-row",
    staticStyle: {
      "margin-top": "8px",
      "font-size": ".6rem"
    }
  }, [_vm._v("\n     重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "1rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-top": "4rem"
    }
  }, [_c('div', {
    staticClass: "page-detail",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.merchandises.specialAnnouncement !== undefined) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filteredShowPromotions && _vm.filteredShowPromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n            "), _vm._l((_vm.filteredShowPromotions), function(proo, index) {
    return _c('div', [_c('span', [_vm._v(_vm._s(index + 1) + ": " + _vm._s(proo.description))])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    style: ({
      'margin-top': '.55rem',
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '35px'
    })
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== 'null' && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList,
        "type": 1
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.price)))])])]), _vm._v(" "), (_vm.merchandises.priceMin) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [(_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])]) : _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.secPromotionDetail && _vm.secPromotionDetail.seckillType === 1) ? _c('span', [_vm._v("¥" + _vm._s(((1 - _vm.secPromotionDetail.seckilltRatio) * _vm.merchandises.priceMin).toFixed(2)))]) : _vm._e()])])]) : _vm._e()], 2), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), (this.$route.query.id === undefined) ? _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'border-top': '0px solid #e7e7e7',
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "background-color": "#00469A",
      "color": "white",
      "width": "80px"
    },
    on: {
      "click": function($event) {
        return _vm.gotofindermerchdisesdetail()
      }
    }
  }, [_c('span', {
    staticClass: "tab-label"
  }, [_vm._v("返回修改")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "width": "10rem"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), (!_vm.isWapp) ? _c('span', [(_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem",
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("确认")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  })]) : _c('span', [(_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem",
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("确认")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n\n            不同产品分装规则说明\n            "), _c('div', [_vm._v("\n              1.菌液:200μL/tube*1\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              2.质粒:不分装\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              3.慢病毒:50μL/tube\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              4.腺病毒:200μL/tube\n            ")]), _c('div', [_vm._v("\n            5.逆转录病毒:50μL/tube\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n              6.腺相关病毒:50μL/tube\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d98287","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/finder/detail/finderOrderDeail.vue
// module id = 1676
// module chunks = 8